import { render, staticRenderFns } from "./DefaultAdmin.vue?vue&type=template&id=740b7336&scoped=true"
import script from "./DefaultAdmin.vue?vue&type=script&lang=js"
export * from "./DefaultAdmin.vue?vue&type=script&lang=js"
import style0 from "./DefaultAdmin.vue?vue&type=style&index=0&id=740b7336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740b7336",
  null
  
)

export default component.exports